module.exports = __webpack_public_path__ + "img/Error.aa3cac4b.png";